import React from 'react';
import { Outlet } from 'react-router-dom';
import { MealTrackingProvider } from '../../contexts/MealTrackingContext';

const MealTrackingLayout: React.FC = () => (
  <MealTrackingProvider>
    <Outlet />
  </MealTrackingProvider>
);

export default MealTrackingLayout;
